import { useDafTracking, getDafTrackingProperties } from "@/canvas/features/FormV2/hooks/useDafTracking";
import { FC } from "react";

import { useController, useFormContext } from "react-hook-form";

import { ProviderPicker } from "./ProviderPicker/ProviderPicker";

import { DonationFormPaymentInput } from "@/common/types/donationForm";

export const DafProviderField: FC = () => {
  const { trackDaf } = useDafTracking();
  const { control, clearErrors } = useFormContext<DonationFormPaymentInput>();
  const { field, fieldState } = useController({ control, name: "dafProviderId" });

  return (
    <ProviderPicker
      value={field.value}
      error={fieldState.error?.message}
      onChange={(providerId) => {
        trackDaf("DAF Provider Selected", getDafTrackingProperties(providerId));
        field.onChange(providerId);
        clearErrors("dafProviderId");
      }}
    />
  );
};
